import { useMemo } from 'react';

import { useDefaultAppContexts } from 'hb-react/frontoffice/contexts/withDefaultAppContexts';
import getCookies from 'hb-react/shared/apps/CookieBanner/utils/getCookies';

import { generateCookieParams } from '../utils/generateCookieParams';

export const useCookieList = (env) => {
  const { currentNetwork } = useDefaultAppContexts();

  return useMemo(() => {
    const cookieParams = generateCookieParams(env, currentNetwork);
    const cookieLists = getCookies(cookieParams);

    return { cookieLists, cookieParams };
  }, [currentNetwork, env]);
};
